import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { subscriptionAPI } from '../lib/api';
import { Loader2, Crown } from 'lucide-react';
import { Button } from './ui/button';

const SubscriptionGate = ({ children }) => {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  // Pages that unsubscribed landlords are allowed to access
  const allowedPaths = ['/landlord/subscription', '/landlord/settings', '/landlord/billing'];
  const isAllowedPath = allowedPaths.some((p) => location.pathname.startsWith(p));

  useEffect(() => {
    if (isAllowedPath) {
      setLoading(false);
      return;
    }
    subscriptionAPI.getMyStatus()
      .then((res) => setStatus(res.data))
      .catch(() => setStatus({ is_active: false }))
      .finally(() => setLoading(false));
  }, [location.pathname]);

  if (isAllowedPath) return children;

  if (loading) {
    return (
      <div className="flex items-center justify-center py-24">
        <Loader2 className="w-8 h-8 animate-spin text-gold" />
      </div>
    );
  }

  if (!status?.is_active) {
    return (
      <div className="min-h-[70vh] flex items-center justify-center p-8" data-testid="subscription-gate-block">
        <div className="text-center max-w-md space-y-6">
          <div className="w-16 h-16 mx-auto bg-gold/10 rounded-full flex items-center justify-center">
            <Crown className="w-8 h-8 text-gold" />
          </div>
          <h2 className="font-serif text-2xl">Subscription Required</h2>
          <p className="text-muted-foreground">
            You need an active plan to manage properties, units, tenants, and payments.
            Choose a subscription plan to unlock full access.
          </p>
          <Button
            onClick={() => navigate('/landlord/subscription')}
            className="bg-gold text-white hover:bg-gold-light font-medium px-8 h-11"
            data-testid="subscribe-now-btn"
          >
            Choose a Plan
          </Button>
        </div>
      </div>
    );
  }

  return children;
};

export default SubscriptionGate;
